export const css = {
	root: 'M5yRMMHC',
	' _key': 'ascm-theme/ascm/variants/ctsc2024ss'
};

export default css;
